<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      appid: 'wx596807efa16908ce',
      // url: 'https://www.izkts.cn/verity',
    }
  },
  created() {
    this.getCodeData();
  },
  methods: {
    // 获取code后跳转到verity页处理数据
    getCodeData() {
      let url = '';
      // 本地/测试环境
      if (process.env.VUE_APP_ENV == 'development' || process.env.VUE_APP_ENV == 'stage') {
        url = 'https://www.izkts.cn/verity';
      } else if (process.env.VUE_APP_ENV == 'production-h5') { // 华为云线上
        url = 'https://www.izkts.com/verity';
      }
      // &forcePopup=true
      let openUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`;
      window.location.href = openUrl;
    }
  }
}
</script>